export const ClientChargeRateTypeReducer = (
state = {
    records: [
        { rateTypeId: 0, description: "Standard" },
        { rateTypeId: 1, description: "Standard Contractor" }
    ]
}) => { return state }